import {createDraftSafeSelector, createSlice} from '@reduxjs/toolkit';

const initialState = {
  isOpen: false,
  severity: 'info',
  message: undefined
};

export const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    setIsSnackbarOpen: (state, action) => {
      state.isOpen = action.payload;
    },
    setSnackbarSeverity: (state, action) => {
      state.severity = action.payload;
    },
    setSnackbarMessage: (state, action) => {
      state.message = action.payload;
    },
    reset: () => initialState
  }
});

// Action creators are generated for each case reducer function
export const {setIsSnackbarOpen, setSnackbarSeverity, setSnackbarMessage} =
  snackbarSlice.actions;

export default snackbarSlice;

const selectSelf = state => state[snackbarSlice.name];

export const selectIsSnackbarOpen = createDraftSafeSelector(
  selectSelf,
  state => state.isOpen
);
export const selectSnackbarSeverity = createDraftSafeSelector(
  selectSelf,
  state => state.severity
);
export const selectSnackbarMessage = createDraftSafeSelector(
  selectSelf,
  state => state.message
);
